module.exports = __webpack_public_path__ + "static/bg-4e29a40feefa9adf50e50ccfd9109885.jpg";